import cssVars from 'css-vars-ponyfill';


const isEmpty = (obj) => {
    if (obj === null || obj === undefined) {
      return true;
    }
}

 const ColorSetTheme = (setTheme,colorSet) => {
          cssVars({
            variables: {
              ...setTheme,
                ...colorSet 
            },
          });
        }

export default ColorSetTheme